import React, { useState, useEffect } from 'react';
import './App.css';
import { database } from './firebase'; // Importamos nuestra conexión
import { ref, onValue, set } from "firebase/database"; // Importamos funciones de la base de datos

import bgImage from './assets/roma_background.png';
import pigImg from './assets/cerdito.png';
import coinImg from './assets/moneda.png';

function App() {
  const [balance, setBalance] = useState(0);
  const [inputAmount, setInputAmount] = useState('');
  const [isAnimating, setIsAnimating] = useState(false);

 // Función para reproducir sonido de monedas (Sintetizado)
  const playCoinSound = () => {
    // Los navegadores a veces suspenden el audio, hay que reanudarlo
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioContext = new AudioContext();
    
    // Si metemos varias monedas, hacemos un pequeño bucle
    const coinCount = 3; // Suena como 3 monedas chocando

    for (let i = 0; i < coinCount; i++) {
        // Frecuencias altas y disonantes para simular metal (entre 2000Hz y 3000Hz)
        const baseFreq = 2000 + (Math.random() * 1000); 
        
        // Tiempo de inicio un poco aleatorio para que no sea robótico
        const startTime = audioContext.currentTime + (Math.random() * 0.15);

        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        // 'triangle' tiene más brillo metálico que 'sine'
        oscillator.type = 'triangle'; 
        oscillator.frequency.value = baseFreq;

        // ENVELOPE (La forma del sonido)
        // Golpe inmediato (0s) y caída muy rápida
        gainNode.gain.setValueAtTime(0, startTime);
        gainNode.gain.linearRampToValueAtTime(0.1, startTime + 0.01); // Volumen bajo (0.1) para no molestar
        gainNode.gain.exponentialRampToValueAtTime(0.001, startTime + 0.6); // Cae rápido

        oscillator.start(startTime);
        oscillator.stop(startTime + 0.6);
    }
  };
  // --- CONEXIÓN A FIREBASE (Leer datos) ---
  useEffect(() => {
    // Referencia a la ubicación 'hucha/saldo' en la base de datos
    const balanceRef = ref(database, 'hucha/saldo');
    
    // Escuchar cambios en tiempo real
    onValue(balanceRef, (snapshot) => {
      const data = snapshot.val();
      if (data !== null) {
        setBalance(parseFloat(data)); // Actualizar estado si hay datos
      } else {
        // Si es la primera vez y no hay nada, inicializamos en 0
        setBalance(0);
      }
    });
  }, []);

  // Función para guardar en Firebase
  const updateBalanceInCloud = (newAmount) => {
    // Escribir el nuevo saldo en la base de datos
    set(ref(database, 'hucha/saldo'), newAmount);
  };

  const getValidAmount = () => {
    const amount = parseFloat(inputAmount);
    if (isNaN(amount) || amount <= 0) {
      alert("Por favor, introduce una cantidad válida.");
      return null;
    }
    return amount;
  };

  // METER DINERO
  const handleAddMoney = (e) => {
    e.preventDefault();
    const amount = getValidAmount();
    if (!amount) return;

    setIsAnimating(true);
    playCoinSound(); // Reproducir sonido de monedas

    // Actualizamos visualmente y en la base de datos tras la animación
    setTimeout(() => {
       const newBalance = balance + amount;
       // IMPORTANTE: Ya no usamos setBalance aquí directamente ni localStorage
       // Guardamos en la nube, y el useEffect de arriba actualizará la pantalla automáticamente
       updateBalanceInCloud(newBalance);
       setInputAmount('');
    }, 800);

    setTimeout(() => {
      setIsAnimating(false);
    }, 2000);
  };

  // QUITAR DINERO
  const handleRemoveMoney = () => {
    const amount = getValidAmount();
    if (!amount) return;

    if (balance - amount < 0) {
      alert("¡No tienes tanto dinero en la hucha para quitar!");
      return;
    }

    const newBalance = balance - amount;
    updateBalanceInCloud(newBalance); // Guardar en la nube
    setInputAmount('');
  };

  return (
    <div className="app-container" style={{ backgroundImage: `url(${bgImage})` }}>
      
      <div className="center-stage">
        <div className="coin-rain-area">
           {isAnimating && <CoinShower coinImg={coinImg} />}
        </div>
        <img 
          src={pigImg} 
          alt="Hucha Cerdito" 
          className={`cartoon-pig ${isAnimating ? 'pig-shaking' : ''}`} 
        />
      </div>

      <div className="ui-card-container">
        <div className="ui-card">
          <h1 className="balance-title">¡¡Nos vamos a Roma!!</h1>
          <div className="balance-amount">€ {balance.toFixed(2)}</div>
          
          <form className="control-form">
            <div className="input-group">
              <span className="currency-symbol">€</span>
              <input 
                type="number" 
                step="0.01" 
                placeholder="0.00"
                value={inputAmount}
                onChange={(e) => setInputAmount(e.target.value)}
                disabled={isAnimating}
              />
            </div>
            
            <div className="button-group">
              <button 
                onClick={handleAddMoney} 
                className="action-button save-button" 
                disabled={isAnimating}
              >
                {isAnimating ? 'Guardando...' : 'Meter +'}
              </button>
              
              <button 
                type="button" 
                onClick={handleRemoveMoney} 
                className="action-button remove-button" 
                disabled={isAnimating}
              >
                Quitar -
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

function CoinShower({ coinImg }) {
  const coins = Array.from({ length: 8 });
  return (
    <>
      {coins.map((_, index) => (
        <img 
          key={index} 
          src={coinImg} 
          alt="moneda" 
          className={`falling-coin coin-${index}`} 
          style={{ left: `${Math.random() * 80 + 10}%` }}
        />
      ))}
    </>
  );
}

export default App;